// @ts-nocheck
import PropTypes from "prop-types";
import React, { useCallback, useRef } from "react";
import orderService from "services/orderService";
import ticketService from "services/ticketService";

const ClickableOrderCodes = ({
  text,
  className = "",
  linkClassName = "text-primary order-code-link",
  isAllowOrderLink = true,
}) => {
  const openingRef = useRef(false);

  const handleClick = useCallback(async (e, code) => {
    e.preventDefault();
    e.stopPropagation();

    if (openingRef.current) return;
    openingRef.current = true;

    try {
      const response = await orderService.searchOrdersByCode(code);
      const order = response.items?.length > 0 ? response.items[0] : null;
      const orderId = order?.id;

      if (orderId) {
        window.open(
          `/manage-orders/${orderId}`,
          "_blank",
          "noopener,noreferrer"
        );
      }
    } catch (error) {
      console.error("Search order error:", error);
    } finally {
      setTimeout(() => {
        openingRef.current = false;
      }, 300);
    }
  }, []);

  const handleTicketClick = useCallback(async (e, code) => {
    e.preventDefault();
    e.stopPropagation();

    if (openingRef.current) return;
    openingRef.current = true;

    try {
      const response = await ticketService.searchTicketByCode(code);
      const items = response?.data?.items || response?.items || [];
      const ticket =
        items.find(item => String(item?.ticket_code || "").trim() === code) || items[0];
      const ticketId = ticket?.id;
      if (ticketId) {
        window.open(
          `/ticket-management/${ticketId}`,
          "_blank",
          "noopener,noreferrer"
        );
      }
    } catch (error) {
      console.error("Search ticket error:", error);
    } finally {
      setTimeout(() => {
        openingRef.current = false;
      }, 300);
    }
  }, []);

  if (!text) return null;

  const orderCodePattern = /\b\d{4}\.[A-Z]{2,3}\.\d{5,}\b/g;
  const ticketCodePattern = /\b\d{4}\.\d{5}\b/g;
  const combinedPattern = /\b\d{4}\.[A-Z]{2,3}\.\d{5,}\b|\b\d{4}\.\d{5}\b/g;
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = combinedPattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push({
        type: "text",
        content: text.substring(lastIndex, match.index),
      });
    }

    const matchedCode = match[0];
    const isOrderCode = orderCodePattern.test(matchedCode);
    const isTicketCode = !isOrderCode && ticketCodePattern.test(matchedCode);
    orderCodePattern.lastIndex = 0;
    ticketCodePattern.lastIndex = 0;

    parts.push({
      type: isTicketCode ? "ticket-link" : "order-link",
      content: matchedCode,
      code: matchedCode,
    });

    lastIndex = match.index + matchedCode.length;
  }

  if (lastIndex < text.length) {
    parts.push({
      type: "text",
      content: text.substring(lastIndex),
    });
  }

  return (
    <span className={className}>
      {parts.map((part, index) =>
        part.type === "order-link" ? (
          isAllowOrderLink ? (
            <a
              key={index}
              role="button"
              className={linkClassName}
              style={{ fontWeight: "bold", cursor: "pointer" }}
              onClick={e => handleClick(e, part.code)}
            >
              {part.content}
            </a>
          ) : (
            <span key={index}>
              {part.content}
            </span>
          )
        ) : part.type === "ticket-link" ? (
          <a
            key={index}
            role="button"
            className={linkClassName}
            style={{ fontWeight: "bold", cursor: "pointer" }}
            onClick={e => handleTicketClick(e, part.code)}
          >
            {part.content}
          </a>
        ) : (
          <span key={index}>{part.content}</span>
        )
      )}
    </span>
  );
};

ClickableOrderCodes.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  linkClassName: PropTypes.string,
  isAllowOrderLink: PropTypes.bool,
};

export default ClickableOrderCodes;
